export const totalStatisticsData = [
  {
    label: 'Mon',
    revenue: 98,
    expenses: 80,
  },
  {
    label: 'Tue',
    revenue: 87,
    expenses: 49,
  },
  {
    label: 'Thu',
    revenue: 50,
    expenses: 86,
  },
  {
    label: 'Wed',
    revenue: 45,
    expenses: 68,
  },
  {
    label: 'Fri',
    revenue: 25,
    expenses: 38,
  },
  {
    label: 'Sat',
    revenue: 80,
    expenses: 59,
  },
  {
    label: 'Sun',
    revenue: 87,
    expenses: 48,
  },
];

export const totalStatisticsLegend = [
  { name: 'Revenue' },
  { name: 'Expenses' },
];

export const financialViewOptions = [
  {
    value: 'Daily',
    label: 'Daily',
  },
  {
    value: 'Monthly',
    label: 'Monthly',
  },
];

export const cashFlowData = [
  {
    label: 'Jan',
    income: 665,
    outgoing: 454,
  },
  {
    label: 'Feb',
    income: 589,
    outgoing: 351,
  },
  {
    label: 'Mar',
    income: 470,
    outgoing: -100,
  },
  {
    label: 'Apr',
    income: 571,
    outgoing: -283,
  },
  {
    label: 'May',
    income: 1050,
    outgoing: 850,
  },
  {
    label: 'Jun',
    income: 750,
    outgoing: -190,
  },
  {
    label: 'Jul',
    income: 875,
    outgoing: 700,
  },
  {
    label: 'Aug',
    income: 568,
    outgoing: 410,
  },
  {
    label: 'Sep',
    income: 775,
    outgoing: 550,
  },
  {
    label: 'Oct',
    income: 680,
    outgoing: 488,
  },
  {
    label: 'Nov',
    income: 580,
    outgoing: 390,
  },
  {
    label: 'Dec',
    income: 438,
    outgoing: 250,
  },
];

export const cashFlowLegend = [{ name: 'Income' }, { name: 'Outgoings' }];
export const CASH_FLOW_COLORS = ['#00766B', '#89BAB5'];

export const burnData = [
  {
    label: 'Mon',
    amount: 1200,
  },
  {
    label: 'Tue',
    amount: 1300,
  },
  {
    label: 'Thu',
    amount: 1150,
  },
  {
    label: 'Wed',
    amount: 700,
  },
  {
    label: 'Fri',
    amount: 900,
  },
  {
    label: 'Sat',
    amount: 600,
  },
  {
    label: 'Sun',
    amount: 790,
  },
];

export const expenseHistoryData = [
  {
    label: 'Mon',
    amount: 70,
  },
  {
    label: 'Tue',
    amount: 50,
  },
  {
    label: 'Thu',
    amount: 60,
  },
  {
    label: 'Wed',
    amount: 30,
  },
  {
    label: 'Fri',
    amount: 82,
  },
  {
    label: 'Sat',
    amount: 90,
  },
  {
    label: 'Sun',
    amount: 65,
  },
];
